import { render, staticRenderFns } from "./NotificationPriorityChip.vue?vue&type=template&id=9bfdd304&scoped=true"
import script from "./NotificationPriorityChip.vue?vue&type=script&lang=js"
export * from "./NotificationPriorityChip.vue?vue&type=script&lang=js"
import style0 from "./NotificationPriorityChip.vue?vue&type=style&index=0&id=9bfdd304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfdd304",
  null
  
)

export default component.exports